import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "goto"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_loading = _resolveComponent("van-loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    name: "wechat",
    size: "128px",
    color: "#d6e7d0"
  }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_loading, {
    size: "24px"
  }, {
    default: _withCtx(() => [_createTextVNode("正在连接微信账户...")]),
    _: 1
  })])])]);
}